import queryString from "query-string";
import useGet from "hooks/useGet";

import { PageLoader } from "components";

const ProductSearch = ({ history, location }) => {
  const { sku } = queryString.parse(location.search);

  useGet({
    query: ["sku", sku],
    path: `/products/search`,
    search: {
      sku,
    },
    onSuccess: ({ data: { product_id } }) => {
      history.push(`/products/${product_id}`);
    },
    onError: () => {
      history.push("/products");
    },
  });
  return <PageLoader />;
};

export default ProductSearch;
